module.exports = __webpack_public_path__ + "img/人面一体机.4de6ba53.jpg";